interface IndexItem {
  title: string;
  desc: string;
  icon: string;
  count: string;
  color: string;
}

const indexItems: IndexItem[] = [
  { title: '热播电视剧', desc: '最新国产剧、韩剧、美剧同步更新', icon: 'ri-tv-2-line', count: '8,600+', color: 'primary' },
  { title: '院线大片', desc: '高清电影资源，蓝光画质畅享', icon: 'ri-film-line', count: '5,200+', color: 'accent' },
  { title: '综艺娱乐', desc: '热门综艺、真人秀一网打尽', icon: 'ri-emotion-laugh-line', count: '3,400+', color: 'secondary' },
  { title: '动漫番剧', desc: '国漫日漫同步更新，追番不等待', icon: 'ri-ghost-line', count: '4,100+', color: 'primary' },
  { title: '纪录片', desc: '自然、历史、科技优质纪录片', icon: 'ri-earth-line', count: '2,300+', color: 'accent' },
  { title: '短剧专区', desc: '精选微短剧，轻松追剧不费时', icon: 'ri-smartphone-line', count: '1,800+', color: 'secondary' },
  { title: '最新上架', desc: '每日新增视频，新鲜热乎抢先看', icon: 'ri-rocket-2-line', count: '每日更新', color: 'primary' },
];

const colorMap: Record<string, { bg: string; text: string; iconBg: string }> = {
  primary: { bg: 'bg-primary-100', text: 'text-primary-700', iconBg: 'bg-primary-500' },
  accent: { bg: 'bg-accent-100', text: 'text-accent-700', iconBg: 'bg-accent-500' },
  secondary: { bg: 'bg-secondary-100', text: 'text-secondary-700', iconBg: 'bg-secondary-500' },
};

export default function Index() {
  return (
    <section id="index" className="w-full py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 bg-primary-100 text-primary-700 text-xs font-semibold rounded-full uppercase tracking-wide">
            精彩索引
          </span>
          <h2 className="mt-4 text-2xl md:text-3xl font-bold text-foreground-950">全站内容导航 · 快速找到你想看的</h2>
          <p className="mt-3 text-foreground-600 max-w-2xl mx-auto text-sm md:text-base">
            覆盖电视剧、电影、综艺、动漫等七大板块，每天同步更新最新资源。
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {indexItems.slice(0, 4).map((item) => {
            const c = colorMap[item.color];
            return (
              <div key={item.title} className="bg-background-50 rounded-xl p-5 border border-background-200/60 hover:border-primary-300/50 transition-all duration-200 cursor-pointer group">
                <div className={`w-10 h-10 rounded-xl ${c.iconBg} flex items-center justify-center mb-3`}>
                  <i className={`${item.icon} text-background-50 text-lg`}></i>
                </div>
                <div className="flex items-center justify-between mb-1">
                  <h3 className="text-base font-bold text-foreground-950">{item.title}</h3>
                  <span className={`text-xs font-semibold px-2 py-0.5 rounded-full ${c.bg} ${c.text} whitespace-nowrap`}>
                    {item.count}
                  </span>
                </div>
                <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            );
          })}
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-5 mt-4 md:mt-5">
          {indexItems.slice(4).map((item) => {
            const c = colorMap[item.color];
            return (
              <div key={item.title} className="bg-background-50 rounded-xl p-5 border border-background-200/60 hover:border-primary-300/50 transition-all duration-200 cursor-pointer group">
                <div className={`w-10 h-10 rounded-xl ${c.iconBg} flex items-center justify-center mb-3`}>
                  <i className={`${item.icon} text-background-50 text-lg`}></i>
                </div>
                <div className="flex items-center justify-between mb-1">
                  <h3 className="text-base font-bold text-foreground-950">{item.title}</h3>
                  <span className={`text-xs font-semibold px-2 py-0.5 rounded-full ${c.bg} ${c.text} whitespace-nowrap`}>
                    {item.count}
                  </span>
                </div>
                <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}